import { z } from 'zod';
import { Validation } from '@mews/framework';
import { AccountType } from '@mews-commander/data-access';
import { creditNoteCounterIdSchema } from '../reinstate/form';
import { fieldNames } from './constants';

const emptyOrMaxLengthStringSchema = (length = 255) => z.string().max(length).or(z.literal(''));
export const addressSchema = z.object({
    addressLine1: emptyOrMaxLengthStringSchema(),
    addressLine2: emptyOrMaxLengthStringSchema(),
    city: emptyOrMaxLengthStringSchema(),
    postalCode: emptyOrMaxLengthStringSchema(),
    countryCode: Validation.String.Empty,
    countrySubdivisionCode: Validation.String.Empty,
});
const changeOwnerSchema = z.object({
    name: z.string().optional(),
    ownerAddressObjection: z.boolean().optional(),
    type: z.nativeEnum(AccountType).optional(),
    address: addressSchema,
});

const changeAssociatedAccountSchema = z.object({
    id: z.string().nullable(),
    associatedAccountAddressObjection: z.boolean().optional(),
    address: addressSchema,
});

export const changeBillingAddressSchema = (creditNoteCounterRequired: boolean) =>
    z.object({
        [fieldNames.creditNoteCounterId]: creditNoteCounterIdSchema(creditNoteCounterRequired),
        associatedAccount: changeAssociatedAccountSchema,
        owner: changeOwnerSchema,
    });
